/**
 * Ansichten-Tabs der Library (Redesign S2 Phase 2a) — vordefinierte URL-Presets
 * (`lib/library-views.ts`), keine gespeicherten Ansichten. Buttons in einer
 * `nav`; der aktive trägt `aria-current="true"`. Bewusst KEIN role=tablist:
 * es gibt keine Tabpanels, jeder Tab ändert nur die URL (wie ein Link).
 * Mobile: horizontal scrollbar, 44px Touch-Ziel.
 */
import { LIBRARY_VIEWS, type LibraryView } from '../lib/library-views';

type Props = {
  /** Aktiver Preset; `null` = URL passt zu keinem Tab (kein Tab markiert). */
  active: LibraryView | null;
  onSelect: (view: LibraryView) => void;
};

export function LibraryViewTabs({ active, onSelect }: Props) {
  return (
    <nav aria-label="Ansichten" className="mb-4 overflow-x-auto">
      <ul className="flex w-max min-w-full gap-1 border-b border-ink-200">
        {LIBRARY_VIEWS.map((view) => {
          const isActive = active === view.id;
          return (
            <li key={view.id}>
              <button
                type="button"
                aria-current={isActive ? 'true' : undefined}
                onClick={() => onSelect(view.id)}
                className={`-mb-px h-11 px-3 border-b-2 text-sm whitespace-nowrap transition focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-green-700 rounded-t-control ${
                  isActive
                    ? 'border-brand-green-700 font-semibold text-brand-green-700'
                    : 'border-transparent font-medium text-ink-500 hover:text-brand-green-700 hover:border-ink-200'
                }`}
              >
                {view.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
